interface WaterfallTabHeaderProps {
  title: string
  description: string
  className?: string
}

export default function WaterfallTabHeader({
  title,
  description,
  className = 'mb-6',
}: WaterfallTabHeaderProps) {
  return (
    <header className={className}>
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      <p className="mt-1 text-sm text-gray-600">{description}</p>
    </header>
  )
}
